import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { CircleIconButtonWithText } from '@/components/ui/Button/CircleIconButtonWithText';
import { AddIcon } from '@/components/ui/SvgIcon/Variable/SvgIconComponents';
/**
 * 案件メンバー追加ボタン
 * @param props
 * @returns
 */
export const RfpMemberAddButton = (props) => {
    const { className = '', disabled = false, onClick } = props;
    return (_jsx(CircleIconButtonWithText, Object.assign({ className: className, disabled: disabled, icon: AddIcon, onClick: onClick, size: 'sm' }, { children: "\u30E1\u30F3\u30D0\u30FC\u3092\u8FFD\u52A0" })));
};
